import classNames from 'classnames';
import React, { FC, memo } from 'react';
import { SizeFilter } from 'features/BoxSizeFilter/model/types';

interface ModernFilterOptionProps {
  label: string;
  description?: string;
  value: SizeFilter;
  isActive: boolean;
  onChange: (value: SizeFilter) => void;
  isDisabled?: boolean;
  sizeCode?: string;
  rowClassName?: string;
}

export const ModernFilterOption: FC<ModernFilterOptionProps> = memo((props) => {
  const { description, value, isActive, onChange, isDisabled, sizeCode, rowClassName } = props;

  const handleClick = (): void => {
    value && !isDisabled && onChange(value);
  };

  return (
    <div
      className={classNames(
        'flex items-stretch rounded-lg border-1.5 cursor-pointer transition-all duration-200 shrink-0 overflow-hidden',
        {
          'border-accent bg-white': isActive,
          'border-black bg-white hover:border-black': !isActive && !isDisabled,
          'border-grey bg-white cursor-not-allowed': isDisabled,
        },
        rowClassName,
      )}
      onClick={handleClick}
    >
      <div className="px-3 py-2 flex flex-col justify-center h-[35px]">
        {description && (
          <div
            className={classNames('text-sm', {
              'text-accent': isActive,
              'text-primary': !isActive && !isDisabled,
              'text-grey cursor-not-allowed': isDisabled,
            })}
          >
            {description}
          </div>
        )}
      </div>

      {sizeCode && (
        <div
          className={classNames('px-3 flex items-center justify-center font-tektur text-white text-md min-w-[35px]', {
            'bg-accent': isActive,
            'bg-black': !isActive && !isDisabled,
            'bg-grey': isDisabled,
          })}
        >
          {sizeCode}
        </div>
      )}
    </div>
  );
});
